
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startListadoMedidas, startUnidadMedidaXID } from "../../../services";






export const useUnidadMedidaXID = (id) => {
    const medidasXIDQuery = useQuery({
        queryKey: ['medidas-id', id], 
        queryFn: () => startUnidadMedidaXID(id),
    });

    return { medidasXIDQuery }
}





export const useUniMedidaQuery = () => {
    
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const unimedidaListQuery = useQuery({
        queryKey: ['medidas-list', { page, termino }], 
        queryFn: () => startListadoMedidas({ page, termino }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        unimedidaListQuery,
    }
}
